import { Component, OnInit } from '@angular/core';
import { EmitterService } from '../common/services/emitter.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { CarouselComponent } from 'ngx-bootstrap/carousel';
import { SharedService } from './../common/services/sharedService';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';
import { Location } from '@angular/common';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';

@Component({
    selector: 'app-custom-header',
    templateUrl: './header.template.html',
    styleUrls: ['./header.style.css'],
    providers: [CarouselComponent]
})
export class HeaderComponent implements OnInit {
    public fromMobileApp = false;
    public ShowProgressInfo = false;
    public ProgressStateInfo: Model.ProgressStateInfo[];
    public securedProductFlag = false;
    public pplProductFlag = false;
    public consentTokenAvailable = false;
    public securedBannerFlag: boolean = false;
    public showHeader: boolean = false;
    public MobParam: any;
    redirectUrl = environment.serviceBaseUrls.DOMAIN02;

    /* public customBanners = [
        {
            imgPath: 'https://www.bajajfinservmarkets.in/content/dam/bajajfinserv/spa-banners/pocket-pl/PPL_feature-banner_Desktop.png',
            imgPathMob: 'https://www.bajajfinservmarkets.in/content/dam/bajajfinserv/spa-banners/pocket-pl/PPL_feature-banner_Mobile.png',
            alt: ''
        },
        {
            imgPath: 'https://www.bajajfinservmarkets.in/content/dam/bajajfinserv/spa-banners/pocket-pl/PPL_feature-banner_Desktop.png',
            imgPathMob: 'https://www.bajajfinservmarkets.in/content/dam/bajajfinserv/spa-banners/pocket-pl/PPL_feature-banner_Mobile.png',
            alt: ''
        },
        {
            imgPath: './assets/img/Revised_icons-146.svg',
            imgPathMob: 'https://www.bajajfinservmarkets.in/content/dam/bajajfinserv/spa-banners/pocket-pl/PPL_feature-banner_Mobile.png',
            alt: ''
        }
    ]; */
    private consentToken: string;
    private prodCode: string;
    public bajajMarketsLogo = environment.serviceBaseUrls.AEMURL + CommonConstants.AEMURLs.CompanyLogoImageUrl;
    bankName: any;
    headerText: any;
    compName: any;
    isMobile: any;
    redirectToIncomeVerification: any;
    processId: any;
    ocrStatus: any;
    epbitly: boolean;
    userDetails:boolean
    inprogressScreen:boolean
    bflOcrIncomeVerification: boolean = false;
    constructor(
        private _emitterService: EmitterService,
        private _cookieHanlder: CookieHandlerService,
        private _activatedRoute: ActivatedRoute,
        private sharedService: SharedService,
        private _route: Router,
        private _location: Location,
        private _routeContextProvider: RouteContextProvider

    ) {
        this._activatedRoute.queryParams.forEach((params) => {
            this.prodCode = params['prodCode'] || CommonConstants.DEFAULT_EMPTY_STRING;
            this.consentToken = params['consentToken'];
            console.log('in header query params fetched', this.prodCode);
            let pdCode;
            if (window.name.length !== 0) {
                pdCode = window.name;
            } else {
                pdCode = this.prodCode;
            }
            this.checkProductCode(pdCode);
        });
    }
    public ngOnInit() {
        const MobVal = this.sharedService.getData(CommonConstants.QueryParamsKeys.IsMobile);
        this.MobParam = (MobVal === '1') ? false : true;
        // let productCode = window.name;
        // console.log('shgffhk',productCode);
        // if (productCode === 'DHL' || productCode === 'DHB' ||
        //     productCode === 'DLAP' || productCode === 'DLAPB') {
        //         this.securedBannerFlag = true;
        //     }


        this._emitterService.Get(CommonConstants.EmitterEventTypes.ProgressStateEvent).subscribe(
            (progressStateInfo: Model.ProgressStateInfo[]) => {
                this.ProgressStateInfo = progressStateInfo;
                console.log('app.component: ' + progressStateInfo);
                this.ShowProgressInfo = true;
            });
        // this._emitterService.Get('productCode').subscribe(
        //     (prodCode) => {
        //         this.checkProductCode();
        //         console.log("in header");
        //     });
        // Mobile header hide
        this._emitterService.Get(CommonConstants.EmitterEventTypes.MobileAppCheck).subscribe(
            (Key: string) => {
                if (Key === '1') {
                    this.fromMobileApp = true;
                }
            });
        if (this.consentToken) {
            this.consentTokenAvailable = true;
        }
        //
        this._route.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe((e: NavigationEnd) => {
                const afterUrl = e.urlAfterRedirects;
                console.log(afterUrl.split("?")[0],'after url')
                if (afterUrl.split('/').includes('bflOcrIncomeVerification')) {
                    // this.showHeader = false;
                    // this.epbitly = false;
                    this.bflOcrIncomeVerification = true;
                }
                else if((afterUrl.split('/').includes(CommonConstants.Routes.Epbitly)) || ((afterUrl.split("?")[0].includes(CommonConstants.Routes.Epbitly)))){
                    // this.showHeader = false;
                    console.log('isnide ep bitly irr')
                    this.epbitly = true;
                    this.userDetails = false;
                    this.inprogressScreen = false;
                }
                else if((afterUrl.split('/').includes(CommonConstants.Routes.userDetails)) || ((afterUrl.split("?")[0].includes(CommonConstants.Routes.userDetails)))){
                    this.userDetails = true;
                    this.epbitly = false;
                    this.inprogressScreen = false;
                }
                else if((afterUrl.split('/').includes(CommonConstants.Routes.inprogessPage)) || ((afterUrl.split("?")[0].includes(CommonConstants.Routes.inprogessPage)))){
                    this.userDetails = false;
                    this.epbitly = false;
                    this.inprogressScreen =true;
                }
                else if((afterUrl.split('/').includes(CommonConstants.Routes.StandAloneBankSelection)) || ((afterUrl.split("?")[0].includes(CommonConstants.Routes.StandAloneBankSelection)))){
                    this.showHeader = false;
                    this.userDetails = false;
                    this.epbitly = false;
                }
                else {
                    this.showHeader = true;
                    // this.epbitly = false;
                }

            });

        this._emitterService.Get(CommonConstants.EmitterEventTypes.HeaderTextChange).subscribe((res) => {
            console.log('response comp name',res)
            if (res.componentName === 'bank-upload') {
                this.compName = res.componentName;
                this.headerText = res.bankName;
            }
            else if(res.componentName === 'account-selection'){
                this.compName = res.componentName;
                this.processId = res.processId;
                this.ocrStatus = res.ocrStatus;
                this.headerText = 'Upload Document';
            }
            
        })
    }
    /*Start: Secured product check */
    private checkProductCode(prdCode) {
        // const prdCode = this._cookieHanlder.GetCookie(CommonConstants.QueryParamsKeys.Productcode);
        console.log('header product code', prdCode);
        if (prdCode === 'DHL' || prdCode === 'DHB' ||
            prdCode === 'DLAP' || prdCode === 'DLAPB') {
            this.securedProductFlag = true;
            this.securedBannerFlag = true;
        } if (prdCode === 'SOL') {
            this.securedProductFlag = false;
        }
        if (prdCode === CommonConstants.productCategoryCode.SPPL) {
            this.pplProductFlag = true;
            this.securedBannerFlag = false;
        }
    }
    /*End: Secured product check */


    goBack() {
        if (this.compName === 'bank-upload') {
            this._route.navigate(['bflOcrIncomeVerification/account-selection'])
        }
        else if(this.compName === 'account-selection') {
            console.log(this.redirectUrl + this.redirectToIncomeVerification,'ttttt');
            const queryParams = `?processId=${this.processId}`+`&ocrStatus=${this.ocrStatus}`;
            this.redirectToIncomeVerification = '/' + this._cookieHanlder.GetCookie(CommonConstants.CookieKeys.redirectionUrlForJourney)+ queryParams;
            window.open(this.redirectUrl + this.redirectToIncomeVerification, '_self');
        }
    }
}
